import React, { useEffect, useMemo, useRef, useState } from 'react'
import configApi from '../../../config';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Tooltip from '@mui/material/Tooltip';
import moment from 'moment'
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom'
import { styled } from '@mui/material/styles';
import LoadingPage from '../../../components/Loading'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { SiMicrosoftexcel } from 'react-icons/si';
import { FaFileCsv, FaHeartBroken, FaInfo, FaEdit, FaLayerGroup } from 'react-icons/fa'
import { MdEdit, MdLocalLaundryService, MdDeliveryDining, MdPayment, MdStore, MdHourglassEmpty, MdOutbox, MdCancel, MdLocationOn, MdContentCopy, MdDirections } from 'react-icons/md'
import { RiSearchEyeLine } from 'react-icons/ri'
import { lookupServiceLocation } from '../../Master/hook/useMasterApi'
import { posReport, posDetailJobStatus, PosSummaryReportDelivery } from '../hook/useReportApi'
import HeaderBar from '../../../components/HeaderBar';
import { getByType } from '../../Master/hook/useListOfValue'
import { Link } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi'
import { Stack } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { IoReceiptSharp } from 'react-icons/io5';
import { GiWashingMachine } from 'react-icons/gi';
import { AiOutlineFileDone } from 'react-icons/ai';
import RejectOrderModal from '../../Retail/RejectOrderModal'
import StatusOrderModal from '../../Retail/StatusOrderModal'
import UpdateSlipModal from '../../Retail/UpdateSlipModal';
import { getCustomerAddressByDeliveryID, getWDFServiceAvailability, getLocationDetail, updateTrackingStep, uploadDeliveryImageB64 } from '../utils/api-action';
import OrderImgUploadModal from '../../../components/OrderImgUploadModal';
import { wdfManualStatus } from '../../Retail/hook/usePosApi';
import { userNameHandler } from '../../../util/local-storage';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// ponytail: static reference data from ops team (not in DB) — service hours + break time per stage.
// Keyed by STAGE value as shown in the table (e.g. "1", "2.1", "3").
// Stage "4" has 2 overlapping roles (M5+M7) covering the whole span with no shared break — shown as one continuous range.
const STAGE_TIME_INFO = {
    "1": { open: "9.00-18.00", breakTime: "13.00-14.00" },
    "2": { open: "10.00-19.00", breakTime: "14.00-15.00" },
    "2.1": { open: "11.00-20.00", breakTime: "15.00-16.00" },
    "3": { open: "9.00-22.00"},
    "4": { open: "9.00-22.00" },
};

function getStageTimeTooltip(stage) {
    // ponytail: DB stores stage as "Stage 2" / "Stage 2.1" — strip the "Stage " prefix to match the lookup key.
    const key = (stage || "").replace(/^Stage\s*/i, "").trim();
    const info = STAGE_TIME_INFO[key];
    if (!info) return "";
    if (!info.breakTime) {
        return <>เวลาเปิด-ปิด: {info.open} น.</>;
    }
    return (
        <>
            เวลาเปิด-ปิด: {info.open} น.<br />
            เวลาพัก: {info.breakTime} น.
        </>
    );
}

// ── Stepper styles ──────────────────────────────────────────────
const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: { top: 22 },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: { backgroundColor: "#303F9F" },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: { backgroundColor: "#303F9F" },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3, border: 1,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderRadius: 1,
    },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#F5F5F5',
    zIndex: 1, color: '#C5CAE9', width: 70, height: 70,
    display: 'flex', borderRadius: '50%', justifyContent: 'center', alignItems: 'center',
    fontSize: '1.5rem', 
    ...(ownerState.active && {
        backgroundColor: '#fff', border: '4px solid #303F9F',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)', color: '#303F9F',
    }),
    ...(ownerState.completed && {
        backgroundColor: '#fff', border: '4px solid #303F9F', color: '#303F9F',
    }),
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': { padding: theme.spacing(2) },
    '& .MuiDialogActions-root': { padding: theme.spacing(1) },
}));
const statusIconMap = {
    'NEW':   <MdHourglassEmpty />,
    'PMT':   <MdPayment />,
    'PMT-D': <MdOutbox />,
    'DROP':  <MdStore />,
    'DDROP': <MdStore />,
    'PUP':   <MdDeliveryDining />,
    'RCV':   <IoReceiptSharp />,
    'WASH':  <GiWashingMachine />,
    'DRY':   <MdLocalLaundryService />,
    'FOLD':  <FaLayerGroup />,
    'DLVD':  <MdDeliveryDining />,
    'POD':   <AiOutlineFileDone />,
    'REJ':   <MdCancel />,
};

// ── Main component ──────────────────────────────────────────────
export default function PosDelivery() {

    const [orderDateForm, setOrderDateForm] = React.useState(moment().format("yyyy-MM-DD"));
    const [orderDateTo, setOrderDateTo] = React.useState(moment().format("yyyy-MM-DD"));
    const [options, setLocations] = useState([]);
    const [optionDeliveryType, setOptionDeliveryType] = useState([]);
    const [value, setValue] = useState([]);
    const [valueDeliveryType, setValueDeliveryType] = useState([]);
    const [cusTel, setCusTel] = React.useState('');

    const [dataDetails, setDataDetails] = useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [total, setTotal] = useState(0);

    const [loadingPageFlag, setLoadingPageFlag] = useState(1);
    const [notifyMessage, setNotifyMessage] = useState("");
    const [typeNotify, setTypeNotify] = React.useState('');
    const [openNotify, setNotify] = React.useState(false);

    const [openDialog, setOpenDialog] = React.useState(false);
    const [currentValue, setCurrentValue] = useState(0);
    const [steps, setSteps] = useState([]);
    const [jobDesc, setJobDesc] = useState([]);
    const [chgLLogs, setChgLLogs] = useState([]);
    const [orderNo, setOrderNo] = useState("");
    const [serviceDate, setServiceDate] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [dataOrder, setDataOrder] = useState({});
    const [showFullPreview, setShowFullPreview] = useState(false);
    const [isUpdateSlipModal, setUpdateSlipModal] = useState(false);
    const [orderDetail, setOrderDetail] = useState(null);
    const [isReject, setIsReject] = useState(false);
    const [isStatusModal, setStatusModal] = useState(false);
    const [selectedIsGrab, setSelectedIsGrab] = useState(false);
    const [selectedIsPaid, setSelectedIsPaid] = useState(false);
    const [selectedSupportOptions, setSelectedSupportOptions] = useState([]);
    const [selectedDeliveryId, setSelectedDeliveryId] = useState(null);
    const [selectedCurrentLocation, setSelectedCurrentLocation] = useState("");
    const [selectedBranchAvailable, setSelectedBranchAvailable] = useState(null);
    const [selectedOrderImg, setSelectedOrderImg] = useState(null);
    const [selectedPupImg, setSelectedPupImg] = useState(null);
    const [selectedDlvdImg, setSelectedDlvdImg] = useState(null);
    const [selectedPickupRef, setSelectedPickupRef] = useState(null);
    const [selectedDeliveryRef, setSelectedDeliveryRef] = useState(null);

    const [trackingDeliveryId, setTrackingDeliveryId] = useState(null);
    const [trackingLocation, setTrackingLocation] = useState('');
    const [trackingOrderImg, setTrackingOrderImg] = useState(null);
    const [trackingPupImg, setTrackingPupImg] = useState(null);
    const [trackingDlvdImg, setTrackingDlvdImg] = useState(null);
    const [trackingPickupRef, setTrackingPickupRef] = useState(null);
    const [trackingDeliveryRef, setTrackingDeliveryRef] = useState(null);
    const [trackingAddressData, setTrackingAddressData] = useState([]);
    const [trackingBranchInfo, setTrackingBranchInfo] = useState(null);
    const [trackingLoadingAddress, setTrackingLoadingAddress] = useState(false);
    const [trackingPreviewImg, setTrackingPreviewImg] = useState(null);

    const [openAddressModal, setOpenAddressModal] = useState(false);
    const [addressData, setAddressData] = useState([]);
    const [addressOrderNo, setAddressOrderNo] = useState("");
    const [addressOrderImg, setAddressOrderImg] = useState(null);
    const [addressPupImg, setAddressPupImg] = useState(null);
    const [addressDlvdImg, setAddressDlvdImg] = useState(null);
    const [addressPickupRef, setAddressPickupRef] = useState(null);
    const [addressDeliveryRef, setAddressDeliveryRef] = useState(null);
    const [loadingAddress, setLoadingAddress] = useState(false);
    const [branchCurrentInfo, setBranchCurrentInfo] = useState(null);
    const [addressCurrentLocation, setAddressCurrentLocation] = useState("");
    const [addressDeliveryType, setAddressDeliveryType] = useState("");
    const [previewImg, setPreviewImg] = useState(null);

    const [editPupRef, setEditPupRef] = useState(false);
    const [editPupRefVal, setEditPupRefVal] = useState('');
    const [savingPupRef, setSavingPupRef] = useState(false);
    const [editDlvdRef, setEditDlvdRef] = useState(false);
    const [editDlvdRefVal, setEditDlvdRefVal] = useState('');
    const [savingDlvdRef, setSavingDlvdRef] = useState(false);
    const [imgUploadOpen, setImgUploadOpen] = useState(false);
    const [imgUploadType, setImgUploadType] = useState('PUP');

    const [openPodBatch, setOpenPodBatch] = useState(false);
    const [isPodUpdating, setIsPodUpdating] = useState(false);
    const [trackingDeliveryType, setTrackingDeliveryType] = useState('');

    const [copiedKey, setCopiedKey] = useState(null);
    const copyCoords = (text, key) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopiedKey(key);
            setTimeout(() => setCopiedKey(null), 1500);
        });
    };

    const [locationStatusMap, setLocationStatusMap] = useState({});
    const [locationFetching, setLocationFetching] = useState(false);
    const locationCacheRef = useRef({});
    const locationFetchGenRef = useRef(0);
    const [branchAvailFilter, setBranchAvailFilter] = useState('ALL');
    const [serviceStatusFilter, setServiceStatusFilter] = useState([]);
    // ── applied client-side filters: มีผลเฉพาะตอนกด "ค้นหา" (ไม่ auto-apply ตอนเปลี่ยน filter) ──
    const [appliedBranchAvail, setAppliedBranchAvail] = useState('ALL');
    const [appliedStatusFilter, setAppliedStatusFilter] = useState([]);
    // ── การ์ดกรองสถานะสำคัญ (เหนือตาราง) — sync 2 ทางกับ serviceStatusFilter/appliedStatusFilter ──
    const [activeStatusCard, setActiveStatusCard] = useState(null); // code ของการ์ดที่ active อยู่ หรือ null
    const [orderNoSort, setOrderNoSort] = useState('desc');
    const [dateSort, setDateSort] = useState(null); // null = ไม่ sort, 'asc', 'desc'
    const [paidDateSort, setPaidDateSort] = useState(null); // null = ไม่ sort, 'asc', 'desc'

    const locationNameMap = useMemo(() =>
        Object.fromEntries(options.map(o => [o.value, o.description])),
    [options]);

    const serviceStatusOptions = [
        // ── active job steps (top — ติ๊กบ่อย) ──
        // { code: 'NEW',   desc: 'รอชำระเงิน' },
        // { code: 'PMT',   desc: 'จ่ายเงินสำเร็จ' },
        { code: 'PMT-D', desc: 'พร้อมรับผ้าจากบ้านลูกค้า' },
        { code: 'PUP',   desc: 'กำลังรับผ้าจากบ้านลูกค้า' },
        // { code: 'DROP',  desc: 'วางผ้าที่สาขาแล้ว' },
        { code: 'RCV',   desc: 'แม่บ้านรับผ้า' },
        { code: 'WASH',  desc: 'ซักผ้า' },
        { code: 'DRY',   desc: 'อบผ้า' },
        // { code: 'CDRY',  desc: 'กำลังพับผ้า' },
        // { code: 'FOLD',  desc: 'พับผ้า' },
        { code: 'DDROP', desc: 'พร้อมส่งผ้าจากสาขา' },
        // { code: 'DLV',   desc: 'กำลังส่ง' },
        { code: 'DLVD',  desc: 'กำลังส่งผ้าจากสาขา' },
        { code: 'POD',   desc: 'ยืนยันรับผ้า' },
        // ── other statuses ──
        
        { code: 'REJ',   desc: 'ลูกค้าขอยกเลิกใช้บริการ' },
    ];

    // ── การ์ดกรองสถานะสำคัญเหนือตาราง — คลิกแล้ว toggle (คลิกซ้ำ = ล้าง), sync 2 ทางกับ serviceStatusFilter ──
    const statusHighlightCards = [
        { code: 'PMT-D', desc: 'พร้อมรับผ้าจากบ้านลูกค้า', icon: MdStore,         color: '#f59e0b' }, // เหลือง
        { code: 'PUP',   desc: 'กำลังรับผ้าจากบ้านลูกค้า', icon: MdHourglassEmpty, color: '#3b82f6' }, // น้ำเงิน
        { code: 'DDROP', desc: 'พร้อมส่งผ้าจากสาขา',       icon: MdOutbox,        color: '#f97316' }, // ส้ม
        { code: 'DLVD',  desc: 'กำลังส่งผ้าจากสาขา',       icon: MdDeliveryDining, color: '#3b82f6' }, // น้ำเงิน
    ];

    const statusHighlightCounts = useMemo(() => {
        const counts = {};
        statusHighlightCards.forEach(c => { counts[c.code] = 0; });
        dataDetails.forEach(row => {
            const code = row["serviceStatusCode"];
            if (counts[code] !== undefined) counts[code]++;
        });
        return counts;
    }, [dataDetails]);

    const onClickStatusCard = (code) => {
        let nextFilter;
        if (activeStatusCard === code) {
            // คลิกอันที่ active อยู่แล้วซ้ำ → ล้าง filter
            setActiveStatusCard(null);
            nextFilter = [];
        } else {
            // คลิกอันใหม่ → ล้างอันเดิม แทนที่ด้วยอันที่เพิ่งคลิก (ทีละอันเท่านั้น)
            const opt = serviceStatusOptions.find(o => o.code === code);
            setActiveStatusCard(code);
            nextFilter = opt ? [opt] : [];
        }
        // กรอง client-side จาก dataDetails ที่ fetch มาแล้ว (fetch เต็ม date range เสมอ — ดู onSearch)
        setServiceStatusFilter(nextFilter);
        setAppliedStatusFilter(nextFilter);
        setPage(0);
    };

    // ── sync กลับจากตัวกรอง "สถานะ Order" ข้างบน (multi-select) → ถ้าตรงกับการ์ดใดพอดี (เลือกแค่ 1 code) ให้ active การ์ดนั้นด้วย ──
    useEffect(() => {
        if (appliedStatusFilter.length === 1 && statusHighlightCards.some(c => c.code === appliedStatusFilter[0].code)) {
            setActiveStatusCard(appliedStatusFilter[0].code);
        } else {
            setActiveStatusCard(null);
        }
    }, [appliedStatusFilter]);

    const filteredDataDetails = useMemo(() => {
        let result = dataDetails;
        if (appliedBranchAvail !== 'ALL') {
            result = result.filter(row => {
                const status = locationStatusMap[row["location"]];
                if (appliedBranchAvail === 'AVAILABLE') return status?.isGreen === true;
                if (appliedBranchAvail === 'NOT_AVAILABLE') return status != null && status.isGreen === false;
                return true;
            });
        }
        if (appliedStatusFilter.length > 0) {
            const codes = new Set(appliedStatusFilter.map(s => s.code));
            result = result.filter(row => codes.has(row["serviceStatusCode"]));
        }
        const parseOrderDate = (s) => {
            // format: "dd/MM/yyyy HH:mm" หรือ "dd/MM/yyyy"
            if (!s) return 0;
            const [datePart, timePart] = s.split(' ');
            const [d, m, y] = datePart.split('/');
            const [hh = '00', mm = '00'] = (timePart || '').split(':');
            return new Date(+y, +m - 1, +d, +hh, +mm).getTime();
        };
        return [...result].sort((a, b) => {
            if (paidDateSort) {
                const diff = parseOrderDate(a["paidDate"]) - parseOrderDate(b["paidDate"]);
                return paidDateSort === 'asc' ? diff : -diff;
            }
            if (dateSort) {
                const diff = parseOrderDate(a["orderDate"]) - parseOrderDate(b["orderDate"]);
                return dateSort === 'asc' ? diff : -diff;
            }
            return orderNoSort === 'asc'
                ? a["orderNo"].localeCompare(b["orderNo"])
                : b["orderNo"].localeCompare(a["orderNo"]);
        });
    }, [dataDetails, locationStatusMap, appliedBranchAvail, appliedStatusFilter, orderNoSort, dateSort, paidDateSort]);

    // ponytail: fetch เต็ม date range เสมอแล้ว (ดู onSearch) → paginate ที่ client เสมอ
    const isClientMode = true;

    const eligiblePodRows = useMemo(() =>
        dataDetails.filter(row => {
            if (row["serviceStatusCode"] !== "DLVD") return false;
            const parts = row["orderDate"]?.split("/");
            if (!parts || parts.length < 3) return false;
            const d = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
            return (new Date() - d) / (1000 * 60 * 60 * 24) <= 548;
        }),
    [dataDetails]);

    const handleBulkPOD = async () => {
        setIsPodUpdating(true);
        const now = moment().format("YYYY-MM-DDTHH:mm");
        const updatedBy = userNameHandler.get();
        const BATCH = 5;
        let failed = 0;
        for (let i = 0; i < eligiblePodRows.length; i += BATCH) {
            const slice = eligiblePodRows.slice(i, i + BATCH);
            const results = await Promise.allSettled(
                slice.map(row =>
                    wdfManualStatus({ serviceNo: row["orderNo"], status: "POD", trackingDate: now, machineQR: "", updatedBy })
                )
            );
            failed += results.filter(r => r.status === "rejected" || r.value?.data?.code !== 200).length;
        }
        setIsPodUpdating(false);
        setOpenPodBatch(false);
        setNotifyMessage(failed === 0
            ? `อัปเดต POD สำเร็จ ${eligiblePodRows.length} orders`
            : `สำเร็จ ${eligiblePodRows.length - failed} / ${eligiblePodRows.length} orders`);
        setTypeNotify(failed === 0 ? "success" : "warning");
        setNotify(true);
        onSearch(page);
    };

    const displayRows = useMemo(() => {
        if (!isClientMode) return filteredDataDetails;
        return filteredDataDetails.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    }, [filteredDataDetails, isClientMode, page, rowsPerPage]);

    const stepIconComponent = useMemo(() => {
        return function ColorlibStepIcon(props) {
            const { active, completed, className } = props;
            const statusCode = jobDesc[props.icon - 1]?.status_code;
            return (
                <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
                    {statusIconMap[statusCode] ?? <AiOutlineFileDone />}
                </ColorlibStepIconRoot>
            );
        };
    }, [jobDesc]);

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    const checkLocationAvailability = async (details) => {
        const gen = ++locationFetchGenRef.current;
        setLocationFetching(true);
        const allUnique = [...new Set([
            ...details.map(r => r["location"]),
        ].filter(Boolean))];
        if (allUnique.length === 0) { setLocationFetching(false); return; }

        const toFetch = allUnique.filter(loc => !(loc in locationCacheRef.current));
        if (toFetch.length > 0) {
            const allResults = [];
            for (let i = 0; i < toFetch.length; i += 5) {
                const batch = toFetch.slice(i, i + 5);
                const batchResults = await Promise.all(
                    batch.map(loc =>
                        getWDFServiceAvailability({ loc })
                            .then(res => ({ loc, res }))
                            .catch(() => ({ loc, res: null }))
                    )
                );
                allResults.push(...batchResults);
            }
            const results = allResults;
            if (gen !== locationFetchGenRef.current) return;
            results.forEach(({ loc, res }) => {
                const item = res?.data?.content;
                if (!item) return;
                const isActive = item.active === "Y";
                const supports = item.supports ?? [];
                supports.forEach(s => {
                    if (!(s.location_Code in locationCacheRef.current)) {
                        locationCacheRef.current[s.location_Code] = {
                            isGreen: s.active === "Y",
                            support: [],
                        };
                    }
                });
                locationCacheRef.current[loc] = {
                    isGreen: isActive,
                    support: supports.map(s => s.location_Code),
                };
            });
        }

        if (gen !== locationFetchGenRef.current) return;
        const map = {};
        allUnique.forEach(loc => {
            map[loc] = locationCacheRef.current[loc] ?? { isGreen: false, support: [] };
        });
        setLocationStatusMap(map);
        setLocationFetching(false);
    };

    useEffect(() => {
        if (dataDetails.length > 0) checkLocationAvailability(dataDetails);
        else { setLocationStatusMap({}); setLocationFetching(false); }
    }, [dataDetails]);

    useEffect(() => {
        lookupServiceLocation().then(function (response) {
            if (response.code === 401) { localStorage.clear(); }
            else { setLocations(response.data.content); }
        });
        getByType({ textSearch: 'DELIVERY_TYPE' }).then(function (response) {
            if (response.code === 401) { localStorage.clear(); }
            else {
    const filtered = (response.data?.content ?? []).filter(m => m.value !== 'N');
    setOptionDeliveryType(filtered);    
    }
        });
        onSearch(0);
    }, []);

    const buildParams = (pageNo, overrideRowsPerPage) => {
        var loc = {
            sDate: orderDateForm,
            eDate: orderDateTo,
            pageSize: overrideRowsPerPage ?? rowsPerPage,
            pageNo: pageNo + 1,
        };
        if (value.length > 0) loc.location = value.map(m => m.value);
        if (cusTel?.trim() !== '') loc.cusTel = cusTel.trim();
        // if (valueDeliveryType.length > 0) loc.deliveryType = valueDeliveryType.map(m => m.value);
        const ALLOWED_DELIVERY_TYPES = ['PT', 'DT', 'RT'];
        const selectedTypes = valueDeliveryType.map(m => m.value).filter(v => v !== 'N');
        loc.deliveryType = selectedTypes.length > 0 ? selectedTypes : ALLOWED_DELIVERY_TYPES;
        return loc;
    };

    const onSearch = async (pageNo, overrideRowsPerPage, statusFilterArg, branchAvailArg, forceFetchAll) => {
        setLoadingPageFlag(1);
        locationCacheRef.current = {};
        // ponytail: fetch เสมอทั้ง date range (ไม่ผูกกับ pageSize UI) — หน้านี้เป็นหน้า operations ที่
        // ต้องเห็นจำนวนจริงตลอดเวลา (การ์ดกรองสถานะ/count) ไม่ยอมให้เลขผิดชั่วคราวก่อนคลิก filter
        const params = buildParams(0, 9999);
        PosSummaryReportDelivery(params).then(function (response) {
            if (response.code === 401) { localStorage.clear(); }
            else {
                setDataDetails(response?.data?.content?.details ?? []);
                setTotal(response?.data?.content?.total ?? 0);
            }
            setLoadingPageFlag(2);
        }).catch(() => localStorage.clear());
    };

    // กด "ค้นหา" / Enter: apply ทุก filter (รวม client-side) แล้วค่อยยิง search
    const runSearch = () => {
        setAppliedStatusFilter(serviceStatusFilter);
        setAppliedBranchAvail(branchAvailFilter);
        setPage(0);
        onSearch(0, undefined, serviceStatusFilter, branchAvailFilter);
    };

    const onViewAddress = async (ordNo, deliveryId, currentLocation, deliveryType, orderImg, pickupRef, deliveryRef, pupImg, dlvdImg) => {
        setAddressOrderNo(ordNo);
        setAddressData([]);
        setBranchCurrentInfo(null);
        setAddressCurrentLocation(currentLocation ?? "");
        setAddressDeliveryType(deliveryType ?? "");
        setAddressOrderImg(orderImg ?? null);
        setAddressPupImg(pupImg ?? null);
        setAddressDlvdImg(dlvdImg ?? null);
        setAddressPickupRef(pickupRef ?? null);
        setAddressDeliveryRef(deliveryRef ?? null);
        setEditPupRef(false); setEditDlvdRef(false);
        setEditPupRefVal(''); setEditDlvdRefVal('');
        setLoadingAddress(true);
        setOpenAddressModal(true);

        const extractBranch = (res, code) => {
            if (!res) return null;
            const content = res?.data?.content;
            const items = Array.isArray(content) ? content : (content ? [content] : []);
            return items.find(i => i.location_Code === code) ?? items[0] ?? null;
        };

        const [custRes, currRes] = await Promise.allSettled([
            getCustomerAddressByDeliveryID({ Delivery_ID: deliveryId }),
            currentLocation ? getLocationDetail({ loc: currentLocation }) : Promise.resolve(null),
        ]);

        if (custRes.status === 'fulfilled') {
            const r = custRes.value;
            if (r?.code === 401) localStorage.clear();
            else setAddressData(r?.data?.content ?? []);
        }

        if (currRes.status === 'fulfilled' && currRes.value) {
            setBranchCurrentInfo(extractBranch(currRes.value, currentLocation));
        }

        setLoadingAddress(false);
    };

    const savePupRef = async () => {
        if (!editPupRefVal.trim()) return;
        setSavingPupRef(true);
        const newUrl = editPupRefVal.trim();
        const res = await updateTrackingStep({ order_no: addressOrderNo, status_code: 'PUP', grab_url: newUrl });
        if (res?.data?.code === 200) {
            setAddressPickupRef(newUrl);
            setEditPupRef(false);
            setDataDetails(prev => prev.map(r => r["orderNo"] === addressOrderNo ? { ...r, pickup_Reference: newUrl } : r));
            setNotifyMessage('บันทึก Grab URL สำเร็จ'); setTypeNotify('success'); setNotify(true);
        } else { setNotifyMessage('บันทึก Grab URL ไม่สำเร็จ'); setTypeNotify('error'); setNotify(true); }
        setSavingPupRef(false);
    };
    const saveDlvdRef = async () => {
        if (!editDlvdRefVal.trim()) return;
        setSavingDlvdRef(true);
        const newUrl = editDlvdRefVal.trim();
        const res = await updateTrackingStep({ order_no: addressOrderNo, status_code: 'DLVD', grab_url: newUrl });
        if (res?.data?.code === 200) {
            setAddressDeliveryRef(newUrl);
            setEditDlvdRef(false);
            setDataDetails(prev => prev.map(r => r["orderNo"] === addressOrderNo ? { ...r, delivery_Reference: newUrl } : r));
            setNotifyMessage('บันทึก Grab URL สำเร็จ'); setTypeNotify('success'); setNotify(true);
        } else { setNotifyMessage('บันทึก Grab URL ไม่สำเร็จ'); setTypeNotify('error'); setNotify(true); }
        setSavingDlvdRef(false);
    };
    const onImgUploadSuccess = (imgPath) => {
        const type = imgUploadType;
        const fullImgUrl = `${configApi.URL_API}File/${imgPath}`;
        type === 'PUP' ? setAddressPupImg(imgPath) : setAddressDlvdImg(imgPath);
        setDataDetails(prev => prev.map(r => r["orderNo"] === addressOrderNo
            ? { ...r, [type === 'PUP' ? 'puP_Image' : 'dlvD_Image']: fullImgUrl }
            : r));
        setNotifyMessage('อัปโหลดรูปสำเร็จ'); setTypeNotify('success'); setNotify(true);
        setImgUploadOpen(false);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        if (!isClientMode) onSearch(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newSize = +event.target.value;
        setRowsPerPage(newSize);
        setPage(0);
        if (!isClientMode) onSearch(0, newSize);
    };

    const loadPOSReport = (e, type) => {
        setLoadingPageFlag(1);
        var loc = buildParams(page);
        loc.fileType = type;
        posReport(loc).then(function (response) {
            if (response.code === 401) { localStorage.clear(); }
            else {
                var fileURL = response.data.content ?? "";
                if (fileURL !== "") {
                    let a = document.createElement('a');
                    a.href = fileURL; a.download = 'posReport'; a.target = "_blank"; a.click();
                } else {
                    setNotifyMessage("Can't Generate File ,Please Try Again!");
                    setTypeNotify('error'); setNotify(true);
                }
            }
            setLoadingPageFlag(2);
        }).catch(() => setLoadingPageFlag(2));
    };

    const toImgSrc = (p) => {
        if (!p) return p;
        if (p.startsWith('data:') || p.startsWith('http')) return p;
        if (p.startsWith('/9j/') || p.startsWith('iVBOR') || p.startsWith('R0lGO') || p.startsWith('UklGR')) return `data:image/jpeg;base64,${p}`;
        return `${configApi.URL_API}File/${p}`;
    };

    const onSearchTracking = function (event, ordNo, orderType, deliveryType, deliveryId, location, orderImg, pupImg, dlvdImg, pickupRef, deliveryRef) {
        setShowFullPreview(false);
        setTrackingDeliveryType(deliveryType ?? '');
        setTrackingDeliveryId(deliveryId ?? null);
        setTrackingLocation(location ?? '');
        setTrackingOrderImg(orderImg ?? null);
        setTrackingPupImg(pupImg ?? null);
        setTrackingDlvdImg(dlvdImg ?? null);
        setTrackingPickupRef(pickupRef ?? null);
        setTrackingDeliveryRef(deliveryRef ?? null);
        setTrackingAddressData([]);
        setTrackingBranchInfo(null);
        setTrackingPreviewImg(null);
        if (deliveryId) {
            setTrackingLoadingAddress(true);
            Promise.allSettled([
                getCustomerAddressByDeliveryID({ Delivery_ID: deliveryId }),
                location ? getLocationDetail({ loc: location }) : Promise.resolve(null),
            ]).then(([custRes, locRes]) => {
                if (custRes.status === 'fulfilled') {
                    const r = custRes.value;
                    if (r?.code !== 401) setTrackingAddressData(r?.data?.content ?? []);
                }
                if (locRes.status === 'fulfilled' && locRes.value) {
                    const content = locRes.value?.data?.content;
                    const items = Array.isArray(content) ? content : (content ? [content] : []);
                    setTrackingBranchInfo(items.find(i => i.location_Code === location) ?? items[0] ?? null);
                }
                setTrackingLoadingAddress(false);
            });
        }
        posDetailJobStatus({ order_no: ordNo, order_type: orderType }).then(function (response) {
            if (response.code === 401) { localStorage.clear(); }
            else {
                let obj = response?.data?.content;
                if (obj?.order_no) {
                    setDataOrder(obj);
                    setSteps(obj.jobs?.map(i => i?.desc ?? "") ?? []);
                    setJobDesc(obj.jobs ?? []);
                    setChgLLogs(obj.chg_l_logs ?? []);
                    setOrderNo(obj.order_no);
                    setServiceDate(obj.service_date);
                    setCustomerName(obj.cust_name);
                    setPhoneNo(obj.cust_tel);
                    if (obj.active !== undefined) setCurrentValue(obj.active);
                    if (obj.delivery_type) setTrackingDeliveryType(obj.delivery_type);
                }
                setOpenDialog(true);
            }
        });
    };

    const passSearchPossummary = () => onSearch(page);

    const showStatus = (statusCode) => {
        if (statusCode === "Y")
            return <div className="p-1 font-bold text-center" style={{ color: "rgb(20 161 110 / 97%)" }}>ชำระเงินแล้ว</div>;
        if (statusCode === "N")
            return <div className="rounded-md bor p-1 font-bold text-white text-center" style={{ backgroundColor: "#FFA500" }}>รอชำระเงิน</div>;
        return <></>;
    };

    // function ColorlibStepIcon(props) {
    //     const { active, completed, className } = props;
    //     const icons = {
    //         1: <IoReceiptSharp />, 2: <GiWashingMachine />,
    //         3: <MdLocalLaundryService />, 4: <FaLayerGroup />, 5: <AiOutlineFileDone />,
    //     };
    //     return (
    //         <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
    //             {icons[String(props.icon)]}
    //         </ColorlibStepIconRoot>
    //     );
    // }

    const BootstrapDialogTitle = (props) => {
        const { children, onClose, ...other } = props;
        return (
            <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
                {children}
                {onClose && (
                    <IconButton aria-label="close" onClick={onClose}
                        sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}>
                        <CloseIcon />
                    </IconButton>
                )}
            </DialogTitle>
        );
    };

    return (
        <div>
            <LoadingPage flag={loadingPageFlag} />
            <HeaderBar parentName="Home " parentUrl="../" url="../posdelivery" functionName="POS Delivery" />

            <div>
                <div className='mx-2'>

                    {/* ── Filter bar ── */}
                    <div className='rounded-b-lg shadow-lg border-opacity-100 border bg-white shadow-gray-500/50 pt-6 pb-6 pl-4 pr-4 mb-2'>
                        <div className='flex flex-wrap gap-2' onKeyDown={(e) => { if (e.key === 'Enter' && !e.defaultPrevented) { runSearch(); } }}>

                            <div className='mr-2'>
                                <TextField size="small" label="วันที่ทำรายการ (เริ่มต้น)" type="date"
                                    defaultValue={orderDateForm} onChange={(e) => setOrderDateForm(e.target.value)}
                                    fullWidth InputLabelProps={{ shrink: true }} />
                            </div>
                            <div className='mr-2'>
                                <TextField size="small" label="วันที่ทำรายการ (สิ้นสุด)" type="date"
                                    defaultValue={orderDateTo} onChange={(e) => setOrderDateTo(e.target.value)}
                                    fullWidth InputLabelProps={{ shrink: true }} />
                            </div>
                            <div className='mr-2'>
                                <TextField size="small" label="เบอร์ผู้ใช้บริการ"
                                    defaultValue={cusTel} onChange={(e) => setCusTel(e.target.value)}
                                    fullWidth InputLabelProps={{ shrink: true }} />
                            </div>
                            <div className='mr-2' style={{ minWidth: "200px", maxWidth: "500px" }}>
                                <Autocomplete multiple disableCloseOnSelect size="small"
                                    options={options} value={value} getOptionLabel={(o) => o.value}
                                    filterOptions={(opts, { inputValue }) => {
                                        const kw = inputValue.toLowerCase();
                                        return opts.filter(o =>
                                            o.value.toLowerCase().includes(kw) ||
                                            (o.description ?? '').toLowerCase().includes(kw)
                                        );
                                    }}
                                    onChange={(e, v) => setValue(v)}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
                                            <div>
                                                <div>{option.value}</div>
                                                {option.description && <div style={{ color: "#6b7280", fontSize: "0.75rem" }}>{option.description}</div>}
                                            </div>
                                        </li>
                                    )}
                                    style={{ width: "100%" }}
                                    renderInput={(params) => <TextField {...params} label="Location" placeholder="Location" />}
                                />
                            </div>
                            <div className='mr-2' style={{ minWidth: "200px", maxWidth: "500px" }}>
                                <Autocomplete multiple disableCloseOnSelect size="small"
                                    options={optionDeliveryType} value={valueDeliveryType} getOptionLabel={(o) => o.description2}
                                    onChange={(e, v) => setValueDeliveryType(v)}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}><Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />{option.description2}</li>
                                    )}
                                    style={{ width: "100%" }}
                                    renderInput={(params) => <TextField {...params} label="Delivery Type" placeholder="Delivery Type" />}
                                />
                            </div>
                            <div className='mr-2' style={{ minWidth: "200px", maxWidth: "400px" }}>
                                <Autocomplete multiple disableCloseOnSelect size="small"
                                    options={serviceStatusOptions}
                                    value={serviceStatusFilter}
                                    getOptionLabel={(o) => o.desc}
                                    isOptionEqualToValue={(o, v) => o.code === v.code}
                                    onChange={(e, v) => setServiceStatusFilter(v)}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
                                            {option.desc}
                                        </li>
                                    )}
                                    style={{ width: "100%" }}
                                    renderInput={(params) => <TextField {...params} label="สถานะ Order" placeholder="สถานะ" />}
                                />
                            </div>
                            <div className='mr-2' style={{ minWidth: "180px" }}>
                                <FormControl size="small" fullWidth>
                                    <InputLabel>สถานะสาขารองรับ</InputLabel>
                                    <Select
                                        value={branchAvailFilter}
                                        label="สถานะสาขารองรับ"
                                        onChange={(e) => setBranchAvailFilter(e.target.value)}
                                    >
                                        <MenuItem value="ALL">ทั้งหมด</MenuItem>
                                        <MenuItem value="AVAILABLE">พร้อมให้บริการ</MenuItem>
                                        <MenuItem value="NOT_AVAILABLE">ไม่พร้อมให้บริการ</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Button variant="contained" onClick={runSearch}>ค้นหา</Button>
                                {eligiblePodRows.length > 0 && (
                                    <Button variant="contained" color="success" startIcon={<AiOutlineFileDone />}
                                        onClick={() => setOpenPodBatch(true)}>
                                        DLVD {eligiblePodRows.length} orders → POD
                                    </Button>
                                )}
                                {(() => {
                                    const exportDisabled = valueDeliveryType.length > 0 || serviceStatusFilter.length > 0 || branchAvailFilter !== 'ALL';
                                    const exportTooltip = exportDisabled ? "ไม่รองรับ filter นี้ในการ export" : "";
                                    return (<>
                                        <Tooltip title={exportTooltip} arrow>
                                            <span>
                                                <Button variant="contained" disabled={exportDisabled} onClick={(e) => loadPOSReport(e, 'xlsx')} startIcon={<SiMicrosoftexcel />}>Excel</Button>
                                            </span>
                                        </Tooltip>
                                        <Tooltip title={exportTooltip} arrow>
                                            <span>
                                                <Button variant="contained" disabled={exportDisabled} onClick={(e) => loadPOSReport(e, 'csv')} startIcon={<FaFileCsv />}>CSV</Button>
                                            </span>
                                        </Tooltip>
                                    </>);
                                })()}
                                {/* <Button component={Link} to="/pos/order/new" variant="contained" startIcon={<FiPlus />}>Delivery Order</Button> */}
                            </Stack>

                        </div>
                    </div>

                    {/* ── การ์ดกรองสถานะสำคัญ ── */}
                    <div className='mb-3'>
                        {/* <label className='text-sm font-semibold text-gray-600 block mb-2'>กรองตามสถานะเดลิเวอรี่</label> */}
                        <div className='flex flex-wrap gap-3'>
                            {statusHighlightCards.map(card => {
                                const isActive = activeStatusCard === card.code;
                                const Icon = card.icon;
                                return (
                                    <button
                                        key={card.code}
                                        onClick={() => onClickStatusCard(card.code)}
                                        className='flex items-center gap-3 rounded-xl px-4 py-3 text-white transition-all duration-200 ease-out'
                                        style={{
                                            backgroundColor: card.color,
                                            minWidth: 170,
                                            border: isActive ? '2px solid rgba(0,0,0,0.35)' : '2px solid transparent',
                                            transform: isActive ? 'scale(1.05)' : 'scale(1)',
                                            boxShadow: isActive ? '0 6px 14px rgba(0,0,0,0.25)' : '0 2px 4px rgba(0,0,0,0.08)',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <Icon size={26} />
                                        <div className='text-left'>
                                            <div className='text-sm font-semibold leading-tight'>{card.desc}</div>
                                            <div className='text-xs opacity-90 mt-0.5'>{statusHighlightCounts[card.code] ?? 0} ออเดอร์</div>
                                        </div>
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    {/* ── Detail table ── */}
                    <div>
                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                            <div className='p-4 font-bold panel-search-detail'><label>List</label></div>
                            <TableContainer>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead sx={{
                                        '& .MuiTableSortLabel-icon': { opacity: 0.35 },
                                        '& .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon': { opacity: 1 },
                                    }}>
                                        <TableRow>
                                            <TableCell sx={{ whiteSpace: "nowrap" }}>ลำดับ</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap", ...(!dateSort && !paidDateSort && { backgroundColor: 'rgba(48,63,159,0.08)' }) }} sortDirection={orderNoSort}>
                                                <TableSortLabel
                                                    active={!dateSort && !paidDateSort}
                                                    direction={orderNoSort}
                                                    onClick={() => {
                                                        setDateSort(null);
                                                        setPaidDateSort(null);
                                                        setOrderNoSort(p => p === 'desc' ? 'asc' : 'desc');
                                                        setPage(0);
                                                    }}
                                                >
                                                    เลขที่รายการ
                                                </TableSortLabel>
                                            </TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap", ...(!!paidDateSort && { backgroundColor: 'rgba(48,63,159,0.08)' }) }} sortDirection={paidDateSort || false}>
                                                <TableSortLabel
                                                    active={!!paidDateSort}
                                                    direction={paidDateSort || 'desc'}
                                                    onClick={() => {
                                                        setDateSort(null);
                                                        setPaidDateSort(p => p === 'desc' ? 'asc' : 'desc');
                                                        setPage(0);
                                                    }}
                                                >
                                                    <span style={{ whiteSpace: 'nowrap' }}>วันที่จ่ายสำเร็จ</span>
                                                </TableSortLabel>
                                            </TableCell>
                                            {/* ponytail: วันที่รายการ ยังไม่ได้ใช้ — comment ทิ้งไว้ ยังไม่ลบ dateSort state/logic เผื่อกลับมาใช้ */}
                                            {/* <TableCell sx={{ whiteSpace: "nowrap", ...(!!dateSort && { backgroundColor: 'rgba(48,63,159,0.08)' }) }} sortDirection={dateSort || false}>
                                                <TableSortLabel
                                                    active={!!dateSort}
                                                    direction={dateSort || 'desc'}
                                                    onClick={() => {
                                                        setPaidDateSort(null);
                                                        setDateSort(p => p === 'desc' ? 'asc' : 'desc');
                                                        setSortAllFetched(true);
                                                        setPage(0);
                                                        onSearch(0, undefined, undefined, undefined, true);
                                                    }}
                                                >
                                                    <span style={{ whiteSpace: 'nowrap' }}>วันที่รายการ</span>
                                                </TableSortLabel>
                                            </TableCell> */}
                                            <TableCell sx={{ whiteSpace: "nowrap" }}>รายละเอียด</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap" }}>ชื่อลูกค้า</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap" }}>เบอร์โทร</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap" }} align="right">ราคา</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap" }}>สาขาใกล้เคียง</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap" }}>สาขาปัจจุบัน</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap" }}>Stage สาขา</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap" }}>หมายเหตุ</TableCell>
                                            <TableCell sx={{ whiteSpace: "nowrap" }}>สถานะ ออเดอร์ / สถานะการชำระเงิน</TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {displayRows.map((row, indexRow) => {
                                            const no = indexRow + 1 + (page * rowsPerPage);
                                            const washTemp = "(" + (
                                                row["washSelectTion"] === "WARM" ? "น้ำอุ่น" :
                                                row["washSelectTion"] === "HOT" ? "น้ำร้อน" :
                                                row["washSelectTion"] === "COLD" ? "น้ำเย็น" : ""
                                            ) + ")";
                                            const detailWash = row["washMachine"] ? " ซัก " + row["washMachine"] : "";
                                            const detailDry = row["dryMachine"] ? " อบ " + row["dryMachine"] : "";
                                            const dryTemp = row["drySelectTion"] ? "(" + row["drySelectTion"] + ")" : "";
                                            const dryAdditionalTime = row["dryAdditionalTime"] > 0 ? ", +" + row["dryAdditionalTime"] : "";
                                            const deliveryDetail = row["delivery_Type_Desc"] ? "Delivery Type :" + row["delivery_Type_Desc"] : "";
                                            const deliveryType  = row["delivery_Type"] ? row["delivery_Type"] : "normal";

                                            const parts = row["orderDate"]?.split("/");
                                            const dateObject = parts ? new Date(parts[2], parts[1] - 1, parts[0]) : new Date();
                                            const isGreaterThanFive = (new Date() - dateObject) / (1000 * 60 * 60 * 24) > 995;
                                            const isOrderGrab = String(row?.orderNo ?? "").trim().startsWith("3");
                                            const isPaidStatus = row?.paid_Status === "Y" ? "Y" : "N";
                                            const checkgrab = String(row?.remark ?? "").trim().startsWith("Delivery Grab;");
                                            const checkDelivery = deliveryType !== "normal" ? true : false;
                                            const isGrabDropReject = row?.serviceStatusCode === "DROP" && checkgrab;
                                            const canReject = isOrderGrab ? isGrabDropReject : (
                                                row["serviceStatusCode"] !== 'NEW' &&
                                                row["serviceStatusCode"] !== 'POD' &&
                                                row["serviceStatusCode"] !== 'DDROP' &&
                                                row["serviceStatusCode"] !== 'REJ' && 
                                                row["serviceStatusCode"] !== 'DLVD'
                                            );
                                            const isRejectStatus = row["serviceStatusCode"] === "REJ";
                                            const canEditStatus = (checkDelivery || checkgrab) ? !isRejectStatus : (
                                                !isGreaterThanFive &&
                                                row["serviceStatusCode"] !== "DDROP" &&
                                                row["serviceStatusCode"] !== "REJ"
                                            );

                                            return (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={indexRow}>
                                                    <TableCell>{no}</TableCell>
                                                    <TableCell>
                                                        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                                                            {row["orderNo"]}
                                                            <MdContentCopy
                                                                size={14}
                                                                title={copiedKey === `orderNo-${indexRow}` ? "คัดลอกแล้ว ✓" : "คัดลอกเลขที่รายการ"}
                                                                style={{ cursor: "pointer", color: copiedKey === `orderNo-${indexRow}` ? "#16a34a" : "#6b7280" }}
                                                                onClick={() => copyCoords(row["orderNo"], `orderNo-${indexRow}`)}
                                                            />
                                                        </span>
                                                    </TableCell>
                                                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                                                        {(() => {
                                                            const [datePart, timePart] = (row["paidDate"] || "").split(" ");
                                                            return (
                                                                <>
                                                                    <div>{datePart}</div>
                                                                    {timePart && <div>{timePart} น.</div>}
                                                                </>
                                                            );
                                                        })()}
                                                    </TableCell>
                                                    {/* ponytail: วันที่รายการ ยังไม่ได้ใช้ — comment ทิ้งไว้ คู่กับ header ด้านบน */}
                                                    {/* <TableCell sx={{ whiteSpace: "nowrap" }}>
                                                        {(() => {
                                                            const [datePart, timePart] = (row["orderDate"] || "").split(" ");
                                                            return (
                                                                <>
                                                                    <div>{datePart}</div>
                                                                    {timePart && <div>{timePart} น.</div>}
                                                                </>
                                                            );
                                                        })()}
                                                    </TableCell> */}
                                                    <TableCell>
                                                        <span>{detailWash}</span><span>{washTemp}</span>
                                                        ,<span>{detailDry}</span><span>{dryTemp}</span>
                                                        <span>{dryAdditionalTime}</span><span>{deliveryDetail}</span>
                                                    </TableCell>
                                                    <TableCell>{row["cust_Name"]}</TableCell>
                                                    <TableCell>{row["cust_Tel"]}</TableCell>
                                                    <TableCell align="right">{row["paymentAmt"]}</TableCell>
                                                    <TableCell>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 4 }}>
                                                        {(locationStatusMap[row["location"]]?.support ?? []).map(s => {
                                                            const sStatus = locationCacheRef.current[s];
                                                            const chipStyle = sStatus?.isGreen
                                                                ? { backgroundColor: "rgba(20, 161, 110, 0.15)", color: "rgb(14, 120, 80)", border: "1px solid rgba(20, 161, 110, 0.4)" }
                                                                : sStatus
                                                                    ? { backgroundColor: "rgba(220, 53, 69, 0.15)", color: "rgb(185, 28, 28)", border: "1px solid rgba(220, 53, 69, 0.4)" }
                                                                    : { backgroundColor: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db" };
                                                            return (
                                                                <Tooltip key={s} title={locationNameMap[s] ?? s} arrow>
                                                                    <span style={{
                                                                        display: "inline-flex",
                                                                        alignItems: "center",
                                                                        lineHeight: 1,
                                                                        padding: "2px 8px",
                                                                        borderRadius: 12,
                                                                        fontSize: "0.75rem",
                                                                        fontWeight: 600,
                                                                        cursor: "default",
                                                                        ...chipStyle,
                                                                    }}>{s}</span>
                                                                </Tooltip>
                                                            );
                                                        })}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell>
                                                        {row["location"] && (() => {
                                                            const locLoading = locationFetching && !locationStatusMap[row["location"]];
                                                            return (
                                                                <Tooltip title={locationNameMap[row["location"]] ?? row["location"]} arrow>
                                                                    <span className={locLoading ? "animate-pulse" : ""}
                                                                        style={{
                                                                            display: "inline-flex",
                                                                            alignItems: "center",
                                                                            lineHeight: 1,
                                                                            padding: "3px 10px",
                                                                            borderRadius: 12,
                                                                            fontSize: "0.75rem",
                                                                            fontWeight: 600,
                                                                            cursor: "default",
                                                                            ...(locationStatusMap[row["location"]]?.isGreen
                                                                                ? { backgroundColor: "rgba(20, 161, 110, 0.15)", color: "rgb(14, 120, 80)", border: "1px solid rgba(20, 161, 110, 0.4)" }
                                                                                : locationStatusMap[row["location"]]
                                                                                    ? { backgroundColor: "rgba(220, 53, 69, 0.15)", color: "rgb(185, 28, 28)", border: "1px solid rgba(220, 53, 69, 0.4)" }
                                                                                    : { backgroundColor: "#f3f4f6", color: "#9ca3af", border: "1px solid #e5e7eb" }
                                                                            ),
                                                                        }}>
                                                                        {row["location"]}
                                                                    </span>
                                                                </Tooltip>
                                                            );
                                                        })()}
                                                    </TableCell>
                                                    <TableCell>
                                                        {(row["stage"] ?? "").trim() && (
                                                            <Tooltip title={getStageTimeTooltip(row["stage"].trim())} arrow>
                                                                <span style={{
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    lineHeight: 1,
                                                                    padding: "3px 10px",
                                                                    borderRadius: 12,
                                                                    fontSize: "0.72rem",
                                                                    fontWeight: 600,
                                                                    cursor: "default",
                                                                    whiteSpace: "nowrap",
                                                                    backgroundColor: "rgba(59,130,246,0.12)",
                                                                    color: "rgb(29,78,216)",
                                                                    border: "1px solid rgba(59,130,246,0.4)",
                                                                }}>
                                                                    {row["stage"].trim()}
                                                                </span>
                                                            </Tooltip>
                                                        )}
                                                    </TableCell>
                                                    <TableCell sx={{ maxWidth: 200, verticalAlign: "top" }}>
                                                        <div style={{
                                                            whiteSpace: "pre-wrap",
                                                            wordBreak: "break-word",
                                                            fontSize: "0.78rem",
                                                            lineHeight: 1.5,
                                                            maxHeight: "80px",
                                                            overflowY: "auto",
                                                            color: "#374151",
                                                        }}>
                                                            {row["remark"]}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell>
                                                        <div className='text-center'
                                                            style={
                                                                row["serviceStatusCode"] === 'PMT-D'
                                                                    ? { backgroundColor: '#FDE047', borderRadius: 6, padding: '2px 6px', fontWeight: 600 }
                                                                    : row["serviceStatusCode"] === 'DDROP'
                                                                        ? { backgroundColor: '#FB923C', borderRadius: 6, padding: '2px 6px', fontWeight: 600, color: '#fff' }
                                                                        : undefined
                                                            }>
                                                            {row["serviceStatus"]}
                                                        </div>
                                                        {showStatus(row["paid_Status"])}
                                                    </TableCell>
                                                    <TableCell>
                                                        <div className='flex justify-center'>
                                                            <IconButton color="primary" title='Status Detail'
                                                                onClick={(e) => onSearchTracking(e, row["orderNo"], row["serviceType"], row["delivery_Type"], row["delivery_ID"], row["location"], row["order_Img"], row["puP_Image"], row["dlvD_Image"], row["pickup_Reference"], row["delivery_Reference"])}>
                                                                <RiSearchEyeLine />
                                                            </IconButton>
                                                            <IconButton color="primary" title='Update Status' disabled={!canEditStatus}
                                                                onClick={() => {
                                                                    setOrderNo(row["orderNo"]);
                                                                    setSelectedIsGrab(isOrderGrab);
                                                                    setSelectedIsPaid(isPaidStatus);
                                                                    const supportCodes = locationStatusMap[row["location"]]?.support ?? [];
                                                                    setSelectedSupportOptions(supportCodes.map(code => ({ serviceCode: code, serviceDesc: locationNameMap[code] ?? code, isActive: locationStatusMap[code]?.isGreen ?? locationCacheRef.current[code]?.isGreen ?? false })));
                                                                    setSelectedDeliveryId(row["delivery_ID"] ?? null);
                                                                    setSelectedCurrentLocation(row["location"] ?? "");
                                                                    setSelectedBranchAvailable(locationStatusMap[row["location"]]?.isGreen ?? null);
                                                                    setSelectedOrderImg(row["order_Img"] ?? null);
                                                                    setSelectedPupImg(row["puP_Image"] ?? null);
                                                                    setSelectedDlvdImg(row["dlvD_Image"] ?? null);
                                                                    setSelectedPickupRef(row["pickup_Reference"] ?? null);
                                                                    setSelectedDeliveryRef(row["delivery_Reference"] ?? null);
                                                                    setStatusModal(true);
                                                                }}>
                                                                <FaEdit />
                                                            </IconButton>
                                                            <IconButton color="primary" title='Reject Order' disabled={!canReject}
                                                                onClick={() => { setOrderNo(row["orderNo"]); setIsReject(true); }}>
                                                                <FaHeartBroken />
                                                            </IconButton>
                                                            {/* <Link to={isOrderGrab ? `/pos/order/view/${row.orderNo}` : "#"}>
                                                                <IconButton disabled={!isOrderGrab} color="primary" title='View Delivery Order'><FaInfo /></IconButton>
                                                            </Link>
                                                            <Link to={isOrderGrab && row?.paid_Status === "N" ? `/pos/order/edit/${row?.orderNo}` : "#"}>
                                                                <IconButton disabled={!(isOrderGrab && row?.paid_Status === "N")} color="primary" title='Edit Delivery Order'><MdEdit /></IconButton>
                                                            </Link> */}
                                                            {/* <IconButton color="primary" title='Delivery Address'
                                                            disabled={!row["delivery_ID"]}
                                                            onClick={() => onViewAddress(row["orderNo"], row["delivery_ID"], row["location"], row["delivery_Type"], row["order_Img"], row["pickup_Reference"], row["delivery_Reference"], row["puP_Image"], row["dlvD_Image"])}>
                                                            <MdLocationOn />
                                                            </IconButton> */}
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 100]}
                                component="div"
                                count={isClientMode ? filteredDataDetails.length : total}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </Paper>
                    </div>

                </div>
            </div>

            {/* ── Tracking dialog ── */}
            <BootstrapDialog onClose={() => setOpenDialog(false)} aria-labelledby="customized-dialog-title" open={openDialog} fullWidth maxWidth="lg">
                <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setOpenDialog(false)}>
                    ตรวจสอบสถานะ
                </BootstrapDialogTitle>
                <DialogContent>
                    <Typography gutterBottom>
                        <div className='pl-10 pr-10 justify-center items-center'>
                            <div className='mb-5 mt-5 flex justify-center items-center'>
                                <div className='border rounded-md pt-5 pb-5 shadow-inner' style={{ width: '85%' }}>
                                    <div className='flex justify-center items-center'>
                                        <div className='pl-2 pr-2 w-2/6'><label className='font-bold'>ชื่อลูกค้า :</label> <label>{customerName}</label></div>
                                        <div className='pl-2 pr-2 w-3/6'><label className='font-bold'>เบอร์โทร :</label> <label>{phoneNo}</label></div>
                                    </div>
                                    <div className='flex justify-center items-center'>
                                        <div className='pl-2 pr-2 w-2/6'><label className='font-bold'>เลขที่ :</label> <label>{orderNo}</label></div>
                                        <div className='pl-2 pr-2 w-3/6'><label className='font-bold'>วันที่ใช้บริการ :</label> <label>{serviceDate}</label></div>
                                    </div>
                                    <div className='flex justify-center items-center'>
                                        <div className='pl-2 pr-2 w-2/6'>
                                            <label className='font-bold'>สาขา :</label> <label>{dataOrder?.location_desc}</label>
                                            {dataOrder?.remark && (
                                                <div className='mt-1'>
                                                    <label className='font-bold'>หมายเหตุ :</label> <label>{dataOrder?.remark}</label>
                                                </div>
                                            )}
                                        </div>
                                        <div className='pl-2 pr-2 w-3/6'>
                                            {dataOrder?.paidDate && (
                                                <div><label className='font-bold'>วันที่ชำระเงินสำเร็จ :</label> <label>{dataOrder?.paidDate}</label></div>
                                            )}
                                            <div className={dataOrder?.paidDate ? 'mt-1' : ''}><label className='font-bold'>สถานะ :</label> <label>{dataOrder?.order_status_desc}</label></div>
                                        </div>
                                    </div>

                                    {/* {dataOrder?.delivery_id && (
                                        <div className='flex justify-center items-center mt-3'>
                                            <div className='pl-2 pr-2 w-2/6'></div>
                                            <div className='pl-2 pr-2 w-3/6'>
                                                <button
                                                    onClick={() => onViewAddress(orderNo, dataOrder.delivery_id)}
                                                    className="inline-flex items-center gap-1 text-sm text-white px-3 py-1 rounded-md"
                                                    style={{ backgroundColor: "#303F9F" }}
                                                >
                                                    <MdLocationOn size={15} />
                                                    ดูที่อยู่จัดส่ง
                                                </button>
                                            </div>
                                        </div>
                                    )} */}

                                </div>
                                {dataOrder?.slip_img && (
                                    <div className="w-1/4 justify-end items-center">
                                        <div style={{ textAlign: "-webkit-center" }} className='text-center'>
                                            <img onClick={() => setShowFullPreview(true)}
                                                style={{ objectFit: "scale-down", maxWidth: "100%", height: "75px", maxHeight: "80px", cursor: "pointer" }}
                                                src={dataOrder.slip_img} alt="OldSlip"
                                                className="drop-shadow-xl rounded-lg max-w-xs cursor-pointer" />
                                        </div>
                                        {showFullPreview && (
                                            <div onClick={() => setShowFullPreview(false)}
                                                style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.8)", zIndex: 999, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <img src={dataOrder.slip_img} alt="Full preview" style={{ maxWidth: "80%", maxHeight: "80%", cursor: "pointer" }} />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className='mb-10 mt-10'>
                                <Stepper activeStep={currentValue ?? 0} alternativeLabel connector={<ColorlibConnector />}>
                                    {steps.map((label, idx) => (
                                        <Step key={label}>
                                            <StepLabel StepIconComponent={stepIconComponent}>{label}
                                                <div className='clear-both'></div>
                                                {jobDesc[idx]?.status_date}
                                                <div className='clear-both'></div>
                                                {jobDesc[idx]?.pic}
                                            </StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                            </div>

                            {/* ── บันทึกการเปลี่ยนสาขา (CHG-L) ── */}
                            {chgLLogs.length > 0 && (
                                <div className='px-10 mb-6'>
                                    <div className='text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2'>
                                        บันทึกการเปลี่ยนสาขา
                                    </div>
                                    {chgLLogs.map((j, i) => (
                                        <div key={i} className='rounded-lg border border-amber-200 bg-amber-50 p-3 mb-2 flex gap-3 items-start'>
                                            <MdLocationOn size={18} className='mt-0.5 flex-shrink-0' style={{ color: "#b45309" }} />
                                            <div className='flex-1'>
                                                {j.remark && (
                                                    <div className='text-sm text-amber-900 font-medium'>{j.remark}</div>
                                                )}
                                                <div className='flex gap-3 mt-0.5'>
                                                    {j.status_date && (
                                                        <span className='text-xs text-gray-500'>{j.status_date}</span>
                                                    )}
                                                    {j.created_by && (
                                                        <span className='text-xs text-gray-400'>โดย {j.created_by}</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                            {/* ── ข้อมูลไรเดอร์ (read-only) ── */}
                            {(trackingOrderImg || trackingPupImg || trackingDlvdImg || trackingPickupRef || trackingDeliveryRef) && (
                                <div className='px-10 mb-4'>
                                    <div className="rounded-xl border border-gray-200 p-3" style={{ backgroundColor: '#f8fafc' }}>
                                        <p className="text-xs font-semibold text-gray-600 mb-3">ข้อมูลไรเดอร์</p>
                                        <div className="flex gap-4 flex-wrap mb-2">
                                            {trackingOrderImg && (
                                                <div className="text-center">
                                                    <div className="text-xs text-gray-500 mb-1">รูปสั่งซัก</div>
                                                    <img src={toImgSrc(trackingOrderImg)} alt="order"
                                                        onClick={() => setTrackingPreviewImg(toImgSrc(trackingOrderImg))}
                                                        style={{ maxHeight: 130, maxWidth: 160, borderRadius: 8, border: '1px solid #e5e7eb', objectFit: 'cover', cursor: 'zoom-in', display: 'block' }} />
                                                </div>
                                            )}
                                            {trackingPupImg && (
                                                <div className="text-center">
                                                    <div className="text-xs text-gray-500 mb-1">รูปไรเดอร์รับผ้า</div>
                                                    <img src={toImgSrc(trackingPupImg)} alt="pup"
                                                        onClick={() => setTrackingPreviewImg(toImgSrc(trackingPupImg))}
                                                        style={{ maxHeight: 130, maxWidth: 160, borderRadius: 8, border: '1px solid #e5e7eb', objectFit: 'cover', cursor: 'zoom-in', display: 'block' }} />
                                                </div>
                                            )}
                                            {trackingDlvdImg && (
                                                <div className="text-center">
                                                    <div className="text-xs text-gray-500 mb-1">รูปไรเดอร์ส่งผ้า</div>
                                                    <img src={toImgSrc(trackingDlvdImg)} alt="dlvd"
                                                        onClick={() => setTrackingPreviewImg(toImgSrc(trackingDlvdImg))}
                                                        style={{ maxHeight: 130, maxWidth: 160, borderRadius: 8, border: '1px solid #e5e7eb', objectFit: 'cover', cursor: 'zoom-in', display: 'block' }} />
                                                </div>
                                            )}
                                        </div>
                                        {trackingPickupRef && (
                                            <div className="flex items-center gap-2 text-xs mb-1.5">
                                                <span className="text-gray-600 font-medium">ไรเดอร์รับผ้า:</span>
                                                <a href={trackingPickupRef} target="_blank" rel="noreferrer" style={{ color: '#15803d', textDecoration: 'underline' }}>ติดตาม ↗</a>
                                            </div>
                                        )}
                                        {trackingDeliveryRef && (
                                            <div className="flex items-center gap-2 text-xs">
                                                <span className="text-gray-600 font-medium">ไรเดอร์ส่งผ้า:</span>
                                                <a href={trackingDeliveryRef} target="_blank" rel="noreferrer" style={{ color: '#15803d', textDecoration: 'underline' }}>ติดตาม ↗</a>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* ── ที่อยู่จัดส่ง (read-only) ── */}
                            {trackingDeliveryId && (
                                <div className='px-10 mb-4'>
                                    <div className="flex items-center gap-3 mb-3">
                                        <div style={{ flex: 1, height: 1, backgroundColor: '#d1d5db' }} />
                                        <span className="flex items-center gap-1.5 text-sm font-semibold" style={{ color: '#111827' }}>
                                            <MdLocationOn size={15} style={{ color: '#303F9F' }} />
                                            ที่อยู่จัดส่ง
                                        </span>
                                        <div style={{ flex: 1, height: 1, backgroundColor: '#d1d5db' }} />
                                    </div>
                                    {trackingLoadingAddress ? (
                                        <div className="flex justify-center py-4">
                                            <div className="animate-spin rounded-full h-6 w-6 border-2 border-gray-200" style={{ borderTopColor: '#303F9F' }} />
                                        </div>
                                    ) : (
                                        <div className="grid gap-3" style={{ gridTemplateColumns: '3fr 2fr', alignItems: 'stretch' }}>
                                            {/* ซ้าย: ที่อยู่ลูกค้า */}
                                            <div className="flex flex-col">
                                                <p className="text-xs font-semibold text-gray-600 mb-2">ที่อยู่ลูกค้า</p>
                                                {trackingAddressData.length === 0 ? (
                                                    <div className="flex-1 rounded-xl border border-dashed border-gray-300 py-4 text-center text-sm text-gray-500">ไม่พบข้อมูล</div>
                                                ) : trackingAddressData.map((addr, idx) => (
                                                    <div key={idx} className="rounded-xl border border-gray-200 p-3 mb-2 last:mb-0 last:flex-1" style={{ backgroundColor: '#f1f5f9' }}>
                                                        <div className="font-semibold text-gray-900 text-sm">{addr.name}</div>
                                                        <div className="text-gray-600 text-xs mt-0.5 mb-2">{addr.mobile_No}</div>
                                                        <div className="text-gray-700 text-xs leading-relaxed mb-2">
                                                            <div>{addr.address}</div>
                                                            <div>{addr.tambon} {addr.amphure}</div>
                                                            <div>{addr.province} {addr.zipcode}</div>
                                                        </div>
                                                        {addr.latitude && addr.longitude && (
                                                            <>
                                                                <div className="flex items-center gap-1 mb-2" style={{ fontSize: 11, color: '#6b7280', fontFamily: 'monospace' }}>
                                                                    <MdLocationOn size={11} style={{ color: '#6b7280', flexShrink: 0 }} />
                                                                    {addr.latitude}, {addr.longitude}
                                                                </div>
                                                                <div className="flex flex-wrap gap-1.5">
                                                                    <button onClick={() => copyCoords(`${addr.latitude},${addr.longitude}`, `t-cust-${idx}`)}
                                                                        className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-md border border-gray-300 bg-white"
                                                                        style={{ color: '#374151' }}
                                                                        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                                                        onMouseLeave={e => e.currentTarget.style.backgroundColor = '#ffffff'}>
                                                                        <MdContentCopy size={12} />
                                                                        {copiedKey === `t-cust-${idx}` ? 'คัดลอกแล้ว ✓' : 'Copy'}
                                                                    </button>
                                                                    <a href={`https://www.google.com/maps?q=${addr.latitude},${addr.longitude}`} target="_blank" rel="noreferrer"
                                                                        className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-md text-white"
                                                                        style={{ backgroundColor: '#303F9F' }}>
                                                                        <MdLocationOn size={12} />แผนที่
                                                                    </a>
                                                                    {trackingBranchInfo?.lat_Long && (
                                                                        <a href={`https://www.google.com/maps/dir/${trackingBranchInfo.lat_Long}/${addr.latitude},${addr.longitude}`} target="_blank" rel="noreferrer"
                                                                            className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-md text-white"
                                                                            style={{ backgroundColor: '#C2410C' }}>
                                                                            <MdDirections size={12} />จุดรับ→สาขา
                                                                        </a>
                                                                    )}
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                            {/* ขวา: สาขาปัจจุบัน */}
                                            <div className="flex flex-col">
                                                <p className="text-xs font-semibold text-gray-600 mb-2">สาขาปัจจุบัน</p>
                                                {trackingLocation && (() => {
                                                    const isGreen = locationStatusMap[trackingLocation]?.isGreen;
                                                    const borderColor = isGreen === true ? '#86efac' : isGreen === false ? '#fca5a5' : '#d1d5db';
                                                    const bgColor    = isGreen === true ? '#f0fdf4' : isGreen === false ? '#fff1f2' : '#f1f5f9';
                                                    const codeColor  = isGreen === true ? { color: '#166534', backgroundColor: '#bbf7d0' } : isGreen === false ? { color: '#991b1b', backgroundColor: '#fecaca' } : { color: '#1f2937', backgroundColor: '#e5e7eb' };
                                                    const mapColor   = isGreen === true ? '#15803d' : isGreen === false ? '#b91c1c' : '#374151';
                                                    return (
                                                        <div className="flex-1 rounded-xl border p-3" style={{ borderColor, backgroundColor: bgColor }}>
                                                            <span className="inline-block font-bold text-sm px-2 py-0.5 rounded-md mb-1.5" style={codeColor}>{trackingLocation}</span>
                                                            {isGreen !== null && isGreen !== undefined && (
                                                                <div className="mb-2">
                                                                    <span className="text-xs font-semibold px-2 py-0.5 rounded-full" style={isGreen ? { backgroundColor: '#dcfce7', color: '#166534', border: '1px solid #86efac' } : { backgroundColor: '#fee2e2', color: '#991b1b', border: '1px solid #fca5a5' }}>
                                                                        {isGreen ? '✓ พร้อมวันนี้' : '✕ ไม่พร้อมวันนี้'}
                                                                    </span>
                                                                </div>
                                                            )}
                                                            {trackingBranchInfo?.location_Thai_Name && <div className="text-gray-900 text-sm font-semibold leading-tight">{trackingBranchInfo.location_Thai_Name}</div>}
                                                            {trackingBranchInfo?.address && <div className="text-gray-600 text-xs mt-1 leading-relaxed">{trackingBranchInfo.address}</div>}
                                                            {trackingBranchInfo?.location_Eng_Name && <div className="text-gray-500 text-xs mt-0.5">{trackingBranchInfo.location_Eng_Name}</div>}
                                                            {trackingBranchInfo?.lat_Long && (
                                                                <>
                                                                    <div className="flex items-center gap-1 mt-2 mb-2" style={{ fontSize: 11, color: '#6b7280', fontFamily: 'monospace' }}>
                                                                        <MdLocationOn size={11} style={{ color: '#6b7280', flexShrink: 0 }} />{trackingBranchInfo.lat_Long}
                                                                    </div>
                                                                    <div className="flex flex-wrap gap-1.5">
                                                                        <button onClick={() => copyCoords(trackingBranchInfo.lat_Long, 't-branch')}
                                                                            className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-md border bg-white"
                                                                            style={{ color: '#374151', borderColor: '#d1d5db' }}
                                                                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                                                            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#ffffff'}>
                                                                            <MdContentCopy size={12} />{copiedKey === 't-branch' ? 'คัดลอกแล้ว ✓' : 'Copy'}
                                                                        </button>
                                                                        <a href={`https://www.google.com/maps?q=${trackingBranchInfo.lat_Long}`} target="_blank" rel="noreferrer"
                                                                            className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-md text-white"
                                                                            style={{ backgroundColor: mapColor }}>
                                                                            <MdLocationOn size={12} />แผนที่
                                                                        </a>
                                                                        {trackingAddressData.find(a => a.latitude && a.longitude) && (
                                                                            <a href={`https://www.google.com/maps/dir/${trackingBranchInfo.lat_Long}/${trackingAddressData.find(a => a.latitude && a.longitude).latitude},${trackingAddressData.find(a => a.latitude && a.longitude).longitude}`}
                                                                                target="_blank" rel="noreferrer"
                                                                                className="inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-md text-white"
                                                                                style={{ backgroundColor: '#0F9D58' }}>
                                                                                <MdDirections size={12} />สาขา→จุดส่ง
                                                                            </a>
                                                                        )}
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    );
                                                })()}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                    </Typography>
                    <UpdateSlipModal
                        isDisplay={isUpdateSlipModal} passSearchPossummary={passSearchPossummary}
                        jobcd={jobDesc ?? ""} dataOrder={dataOrder} orderNo={orderNo} orderDetail={orderDetail}
                        onClose={() => setUpdateSlipModal(false)}
                        onSuccess={() => { onSearch(page); setUpdateSlipModal(false); }}
                    />
                </DialogContent>
            </BootstrapDialog>

            <BootstrapDialog onClose={() => { setOpenAddressModal(false); setEditPupRef(false); setEditDlvdRef(false); setEditPupRefVal(''); setEditDlvdRefVal(''); }} open={openAddressModal} fullWidth maxWidth="md">
                    <BootstrapDialogTitle id="address-dialog-title" onClose={() => { setOpenAddressModal(false); setEditPupRef(false); setEditDlvdRef(false); setEditPupRefVal(''); setEditDlvdRefVal(''); }}>
                        <div className="flex items-center gap-2">
                            <MdLocationOn size={22} color="#303F9F" />
                            <span>ที่อยู่จัดส่ง</span>
                            <span className="text-sm font-normal text-gray-500 ml-1">#{addressOrderNo}</span>
                        </div>
                    </BootstrapDialogTitle>
                    <DialogContent>
                    {loadingAddress ? (
                        <div className="flex justify-center items-center py-10">
                            <div className="animate-spin rounded-full h-10 w-10 border-4 border-gray-200"
                                style={{ borderTopColor: "#303F9F" }} />
                        </div>
                    ) : (
                        <>
                            {/* ── รูปตะกร้าผ้า + Grab URL ── */}
                            {/* ponytail: แสดงเสมอสำหรับ delivery order (เดิม gate ด้วย Grab URL ที่มีอยู่แล้ว
                                ทำให้ order ที่ยังไม่มี Grab URL ใส่ลิงก์/อัปรูปไม่ได้ — bug LU delivery) */}
                            {true && (
                                <div className="mb-4 rounded-lg border border-gray-200 p-3">
                                    <div className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">ข้อมูลไรเดอร์</div>
                                    <div className="flex gap-3 flex-wrap mb-2">
                                        {addressOrderImg && (
                                            <div style={{ textAlign: 'center' }}>
                                                <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>รูปสั่งซัก</div>
                                                <img src={toImgSrc(addressOrderImg)} alt="order" onClick={() => setPreviewImg(toImgSrc(addressOrderImg))} style={{ maxHeight: 180, maxWidth: 220, borderRadius: 6, border: "1px solid #e5e7eb", objectFit: 'cover', cursor: 'zoom-in' }} />
                                            </div>
                                        )}
                                        <div style={{ textAlign: 'center' }}>
                                            <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>รูปไรเดอร์รับผ้า</div>
                                            {addressPupImg && (
                                                <img src={toImgSrc(addressPupImg)} alt="pup" onClick={() => setPreviewImg(toImgSrc(addressPupImg))} style={{ maxHeight: 180, maxWidth: 220, borderRadius: 6, border: "1px solid #e5e7eb", objectFit: 'cover', cursor: 'zoom-in' }} />
                                            )}
                                            <div style={{ marginTop: 4 }}>
                                                <Button size="small" variant="outlined"
                                                    onClick={() => { setImgUploadType('PUP'); setImgUploadOpen(true); }}
                                                    style={{ fontSize: 11, padding: '2px 8px', borderStyle: 'dashed', color: '#303F9F', borderColor: '#303F9F' }}>
                                                    {addressPupImg ? 'เปลี่ยนรูป' : 'อัปโหลดรูปรับผ้า'}
                                                </Button>
                                            </div>
                                        </div>
                                        <div style={{ textAlign: 'center' }}>
                                            <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>รูปไรเดอร์ส่งผ้า</div>
                                            {addressDlvdImg && (
                                                <img src={toImgSrc(addressDlvdImg)} alt="dlvd" onClick={() => setPreviewImg(toImgSrc(addressDlvdImg))} style={{ maxHeight: 180, maxWidth: 220, borderRadius: 6, border: "1px solid #e5e7eb", objectFit: 'cover', cursor: 'zoom-in' }} />
                                            )}
                                            <div style={{ marginTop: 4 }}>
                                                <Button size="small" variant="outlined"
                                                    onClick={() => { setImgUploadType('DLVD'); setImgUploadOpen(true); }}
                                                    style={{ fontSize: 11, padding: '2px 8px', borderStyle: 'dashed', color: '#303F9F', borderColor: '#303F9F' }}>
                                                    {addressDlvdImg ? 'เปลี่ยนรูป' : 'อัปโหลดรูปส่งผ้า'}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ marginBottom: 4, display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                                        <span style={{ fontSize: 12, color: '#6b7280' }}>ไรเดอร์รับผ้า: </span>
                                        {editPupRef ? (
                                            <>
                                                <TextField size="small" value={editPupRefVal} onChange={e => setEditPupRefVal(e.target.value)}
                                                    placeholder="วางลิงก์ Grab" inputProps={{ style: { fontSize: 12, padding: '4px 8px' } }} style={{ flex: 1, minWidth: 220 }} />
                                                <Button size="small" variant="contained" disabled={savingPupRef || !editPupRefVal.trim()} onClick={savePupRef}>
                                                    {savingPupRef ? '...' : 'บันทึก'}
                                                </Button>
                                                <IconButton size="small" onClick={() => setEditPupRef(false)}><CloseIcon fontSize="small" /></IconButton>
                                            </>
                                        ) : addressPickupRef ? (
                                            <>
                                                <a href={addressPickupRef} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#15803d', textDecoration: 'underline' }}>ติดตาม ↗</a>
                                                <IconButton size="small" onClick={() => { setEditPupRef(true); setEditPupRefVal(addressPickupRef); }}><MdEdit size={14} /></IconButton>
                                            </>
                                        ) : (
                                            <Button size="small" variant="outlined" onClick={() => { setEditPupRef(true); setEditPupRefVal(''); }}
                                                style={{ fontSize: 11, padding: '2px 8px', borderStyle: 'dashed', color: '#303F9F', borderColor: '#303F9F' }}>
                                                + ใส่ลิงก์
                                            </Button>
                                        )}
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                                        <span style={{ fontSize: 12, color: '#6b7280' }}>ไรเดอร์ส่งผ้า: </span>
                                        {editDlvdRef ? (
                                            <>
                                                <TextField size="small" value={editDlvdRefVal} onChange={e => setEditDlvdRefVal(e.target.value)}
                                                    placeholder="วางลิงก์ Grab" inputProps={{ style: { fontSize: 12, padding: '4px 8px' } }} style={{ flex: 1, minWidth: 220 }} />
                                                <Button size="small" variant="contained" disabled={savingDlvdRef || !editDlvdRefVal.trim()} onClick={saveDlvdRef}>
                                                    {savingDlvdRef ? '...' : 'บันทึก'}
                                                </Button>
                                                <IconButton size="small" onClick={() => setEditDlvdRef(false)}><CloseIcon fontSize="small" /></IconButton>
                                            </>
                                        ) : addressDeliveryRef ? (
                                            <>
                                                <a href={addressDeliveryRef} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#15803d', textDecoration: 'underline' }}>ติดตาม ↗</a>
                                                <IconButton size="small" onClick={() => { setEditDlvdRef(true); setEditDlvdRefVal(addressDeliveryRef); }}><MdEdit size={14} /></IconButton>
                                            </>
                                        ) : (
                                            <Button size="small" variant="outlined" onClick={() => { setEditDlvdRef(true); setEditDlvdRefVal(''); }}
                                                style={{ fontSize: 11, padding: '2px 8px', borderStyle: 'dashed', color: '#303F9F', borderColor: '#303F9F' }}>
                                                + ใส่ลิงก์
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            )}
                            {/* ── ที่อยู่ลูกค้า ── */}
                            <div className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">ที่อยู่จัดส่งลูกค้า</div>
                            {addressData.length === 0 ? (
                                <div className="text-center py-6 text-gray-400 mb-3">
                                    <MdLocationOn size={36} className="mx-auto mb-1 opacity-30" />
                                    <div className="text-sm">ไม่พบข้อมูลที่อยู่จัดส่ง</div>
                                </div>
                            ) : addressData.map((addr, idx) => (
                                <div key={idx} className="rounded-lg border border-gray-200 shadow-sm p-4 mb-3 bg-white">
                                    <div className="mb-2 pb-2 border-b border-gray-100">
                                        <div className="font-bold text-gray-800 text-base">{addr.name}</div>
                                        <div className="text-gray-500 text-sm">{addr.mobile_No}</div>
                                    </div>
                                    <div className="text-gray-700 text-sm leading-6 mb-3">
                                        <div>{addr.address}</div>
                                        <div>{addr.tambon} {addr.amphure}</div>
                                        <div>{addr.province} {addr.zipcode}</div>
                                    </div>
                                    {addr.latitude && addr.longitude && (
                                        <>
                                        <div style={{ fontSize: 11, color: '#6b7280', fontFamily: 'monospace', marginBottom: 4 }}>
                                            📍 {addr.latitude}, {addr.longitude}
                                        </div>
                                        <div className="flex flex-wrap gap-2 mt-1">
                                            <button
                                                onClick={() => copyCoords(`${addr.latitude},${addr.longitude}`, `cust-${idx}`)}
                                                className="inline-flex items-center gap-1 text-sm px-3 py-1 rounded-md border"
                                                style={{ color: "#374151", borderColor: "#d1d5db", backgroundColor: "#f9fafb" }}>
                                                <MdContentCopy size={14} />
                                                {copiedKey === `cust-${idx}` ? "คัดลอกแล้ว!" : "Copy"}
                                            </button>
                                            <a href={`https://www.google.com/maps?q=${addr.latitude},${addr.longitude}`}
                                                target="_blank" rel="noreferrer"
                                                className="inline-flex items-center gap-1 text-sm text-white px-3 py-1 rounded-md"
                                                style={{ backgroundColor: "#303F9F" }}>
                                                <MdLocationOn size={15} />
                                                ดูแผนที่
                                            </a>
                                            {branchCurrentInfo?.lat_Long && (
                                                <a href={`https://www.google.com/maps/dir/${addr.latitude},${addr.longitude}/${branchCurrentInfo.lat_Long}`}
                                                    target="_blank" rel="noreferrer"
                                                    className="inline-flex items-center gap-1 text-sm text-white px-3 py-1 rounded-md"
                                                    style={{ backgroundColor: "#E65100" }}>
                                                    <MdDirections size={15} />
                                                    จุดรับ → สาขา
                                                </a>
                                            )}
                                        </div>
                                        </>
                                    )}
                                </div>
                            ))}

                            {/* ── สาขาปัจจุบัน ── */}
                            {addressCurrentLocation && (() => {
                                const info   = branchCurrentInfo;
                                const nameDesc = locationNameMap[addressCurrentLocation];
                                const apiDesc  = info?.location_Desc;
                                const locStatus = locationStatusMap[addressCurrentLocation];
                                const isGreen = locStatus?.isGreen;
                                const cardStyle = isGreen
                                    ? { borderColor: "rgba(20, 161, 110, 0.4)", backgroundColor: "rgba(20, 161, 110, 0.07)" }
                                    : locStatus
                                        ? { borderColor: "rgba(220, 53, 69, 0.4)", backgroundColor: "rgba(220, 53, 69, 0.07)" }
                                        : { borderColor: "#d1d5db", backgroundColor: "#f9fafb" };
                                const codeStyle = isGreen
                                    ? { color: "rgb(14, 120, 80)", backgroundColor: "rgba(20, 161, 110, 0.15)" }
                                    : locStatus
                                        ? { color: "rgb(185, 28, 28)", backgroundColor: "rgba(220, 53, 69, 0.15)" }
                                        : { color: "#374151", backgroundColor: "#f3f4f6" };
                                const mapBtnColor = isGreen ? "#2e7d32" : locStatus ? "#b91c1c" : "#374151";
                                return (
                                    <>
                                        <div className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 mt-4">สาขาปัจจุบัน</div>
                                        <div className="rounded-lg border shadow-sm p-4" style={cardStyle}>
                                            <div className="flex items-center gap-2 mb-1 flex-wrap">
                                                <span className="font-bold text-sm px-2 py-0.5 rounded" style={codeStyle}>{addressCurrentLocation}</span>
                                                {locStatus != null && (
                                                    <span style={{
                                                        fontSize: "0.7rem", fontWeight: 600,
                                                        padding: "2px 8px", borderRadius: 999,
                                                        ...(isGreen
                                                            ? { backgroundColor: "rgba(20,161,110,0.15)", color: "rgb(14,120,80)", border: "1px solid rgba(20,161,110,0.4)" }
                                                            : { backgroundColor: "rgba(220,53,69,0.15)", color: "rgb(185,28,28)", border: "1px solid rgba(220,53,69,0.4)" }
                                                        ),
                                                    }}>
                                                        {isGreen ? "✓ พร้อมให้บริการวันนี้" : "✕ ไม่พร้อมให้บริการวันนี้"}
                                                    </span>
                                                )}
                                            </div>
                                            {(info?.location_Thai_Name || nameDesc) && (
                                                <div className="text-gray-700 text-sm font-medium">{info?.location_Thai_Name || nameDesc}</div>
                                            )}
                                            {info?.address && (
                                                <div className="text-gray-600 text-sm mt-1">{info.address}</div>
                                            )}
                                            {info?.location_Eng_Name && (
                                                <div className="text-gray-700 text-xs mt-1">{info.location_Eng_Name}</div>
                                            )}
                                            {info?.lat_Long && (
                                                <>
                                                <div style={{ fontSize: 11, color: '#6b7280', fontFamily: 'monospace', marginBottom: 4 }}>
                                                    📍 {info.lat_Long}
                                                </div>
                                                <div className="flex flex-wrap gap-2 mt-2">
                                                    <button
                                                        onClick={() => copyCoords(info.lat_Long, 'branch')}
                                                        className="inline-flex items-center gap-1 text-sm px-3 py-1 rounded-md border"
                                                        style={{ color: "#374151", borderColor: "#d1d5db", backgroundColor: "#f9fafb" }}>
                                                        <MdContentCopy size={14} />
                                                        {copiedKey === 'branch' ? "คัดลอกแล้ว!" : "Copy"}
                                                    </button>
                                                    <a href={`https://www.google.com/maps?q=${info.lat_Long}`}
                                                        target="_blank" rel="noreferrer"
                                                        className="inline-flex items-center gap-1 text-sm text-white px-3 py-1 rounded-md"
                                                        style={{ backgroundColor: mapBtnColor }}>
                                                        <MdLocationOn size={15} />
                                                        ดูแผนที่สาขา
                                                    </a>
                                                    {(() => {
                                                        const firstCust = addressData.find(a => a.latitude && a.longitude);
                                                        if (!firstCust) return null;
                                                        return (
                                                            <a href={`https://www.google.com/maps/dir/${info.lat_Long}/${firstCust.latitude},${firstCust.longitude}`}
                                                                target="_blank" rel="noreferrer"
                                                                className="inline-flex items-center gap-1 text-sm text-white px-3 py-1 rounded-md"
                                                                style={{ backgroundColor: "#0F9D58" }}>
                                                                <MdDirections size={15} />
                                                                สาขา → จุดส่ง
                                                            </a>
                                                        );
                                                    })()}
                                                </div>
                                                </>
                                            )}
                                        </div>
                                    </>
                                );
                            })()}
                        </>
                    )}
                    </DialogContent>
            </BootstrapDialog>
            

            <BootstrapDialog open={openPodBatch} onClose={() => { if (!isPodUpdating) setOpenPodBatch(false); }} fullWidth maxWidth="sm">
                <BootstrapDialogTitle id="pod-batch-title" onClose={() => { if (!isPodUpdating) setOpenPodBatch(false); }}>
                    อัปเดตสถานะ DLVD → POD ({eligiblePodRows.length} orders)
                </BootstrapDialogTitle>
                <DialogContent>
                    <div className="text-xs text-gray-400 mb-2">* แสดงเฉพาะ orders สถานะ DLVD ที่โหลดมาในผลค้นหาปัจจุบัน (ภายใน 18 เดือน)</div>
                    <div style={{ maxHeight: 320, overflowY: "auto" }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ whiteSpace: "nowrap" }}>เลขที่รายการ</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }}>ชื่อลูกค้า</TableCell>
                                    <TableCell sx={{ whiteSpace: "nowrap" }}>วันที่รายการ</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {eligiblePodRows.map((row, i) => (
                                    <TableRow key={i}>
                                        <TableCell>{row["orderNo"]}</TableCell>
                                        <TableCell>{row["cust_Name"]}</TableCell>
                                        <TableCell>{row["orderDate"]}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                    <div className="flex justify-end mt-4 gap-2">
                        <Button variant="outlined" onClick={() => setOpenPodBatch(false)} disabled={isPodUpdating}>ยกเลิก</Button>
                        <Button variant="contained" color="success" startIcon={<AiOutlineFileDone />}
                            onClick={handleBulkPOD} disabled={isPodUpdating}>
                            {isPodUpdating ? "กำลังอัปเดต..." : `Confirm Update ${eligiblePodRows.length} orders`}
                        </Button>
                    </div>
                </DialogContent>
            </BootstrapDialog>

            <RejectOrderModal isDisplay={isReject} orderNo={orderNo} onClose={() => setIsReject(false)} />

            {isStatusModal && (
                <StatusOrderModal passSearchPossummary={passSearchPossummary} isGrabOrder={selectedIsGrab}
                    isPaid={selectedIsPaid} isDisplay={isStatusModal} orderNo={orderNo}
                    supportOptions={selectedSupportOptions}
                    deliveryId={selectedDeliveryId}
                    currentLocation={selectedCurrentLocation}
                    branchAvailable={selectedBranchAvailable}
                    orderImg={selectedOrderImg}
                    pupImg={selectedPupImg}
                    dlvdImg={selectedDlvdImg}
                    pickupRef={selectedPickupRef}
                    deliveryRef={selectedDeliveryRef}
                    onClose={() => setStatusModal(false)}
                    onSuccess={() => { onSearch(page); }} />
            )}

            <OrderImgUploadModal
                open={imgUploadOpen}
                onClose={() => setImgUploadOpen(false)}
                serviceNo={addressOrderNo}
                stepContext={imgUploadType}
                grabUrl={imgUploadType === 'PUP' ? addressPickupRef : addressDeliveryRef}
                onSuccess={onImgUploadSuccess}
            />

            <Dialog open={!!previewImg} onClose={() => setPreviewImg(null)} maxWidth="md">
                <img src={previewImg} alt="preview" onClick={() => setPreviewImg(null)} style={{ display: 'block', maxWidth: '90vw', maxHeight: '90vh', cursor: 'zoom-out' }} />
            </Dialog>

            <Dialog open={!!trackingPreviewImg} onClose={() => setTrackingPreviewImg(null)} maxWidth="md">
                <img src={trackingPreviewImg} alt="preview" onClick={() => setTrackingPreviewImg(null)} style={{ display: 'block', maxWidth: '90vw', maxHeight: '90vh', cursor: 'zoom-out' }} />
            </Dialog>

            <Snackbar open={openNotify} autoHideDuration={6000} onClose={() => setNotify(false)} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert onClose={() => setNotify(false)} severity={typeNotify} sx={{ width: '100%' }}>{notifyMessage}</Alert>
            </Snackbar>
        </div>
    );
}
